const viewAny = (permissions) => {
  return permissions.includes('read-vehicle-make')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-vehicle-make')
}

const update = (permissions, make) => {
  return hasPermission(permissions, 'update-vehicle-make')
}

const deletee = (permissions, make) => {
  return hasPermission(permissions, 'delete-vehicle-make')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};